// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeyboardPage_root__trOgd {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;

  background: #ffffff;
  border-top: 1px solid rgba(0, 0, 0, 0.12);

  box-shadow: 0 -16px 40px rgba(0, 0, 0, 0.12);
  padding: 12px 14px 14px;
}

.KeyboardPage_root__trOgd {
  font-family: "Inter", "Noto Sans", system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Arial, sans-serif;
}

/* top row */
.KeyboardPage_topRow__t1bSF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.KeyboardPage_title__RnS69 {
  font-size: 14px;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.75);
}

.KeyboardPage_controls__8gskj {
  display: flex;
  align-items: center;
  gap: 8px;
}

.KeyboardPage_ctrlBtn__nZyU- {
  height: 38px;
  min-width: 54px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,0.12);
  background: #f6f7f8;
  font-weight: 800;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.KeyboardPage_ctrlBtn__nZyU-:hover {
  background: #eef1f3;
}

.KeyboardPage_okBtn__Ej3Ec {
  height: 38px;
  min-width: 64px;
  padding: 0 14px;
  border-radius: 10px;
  border: none;
  background: rgba(29, 135, 82, 1);
  color: #fff;
  font-weight: 900;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.KeyboardPage_okBtn__Ej3Ec:hover {
  opacity: 0.95;
}

.KeyboardPage_closeBtn__7w557 {
  height: 38px;
  width: 38px;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,0.12);
  background: #fff;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.KeyboardPage_closeBtn__7w557:hover {
  background: rgba(0,0,0,0.05);
}

/* input */
.KeyboardPage_inputRow__rtXsH {
  margin-bottom: 12px;
}

.KeyboardPage_input__UoBkX {
  width: 100%;
  height: 44px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 12px;
  padding: 0 12px;
  font-size: 16px;
  outline: none;
}

/* main grid */
.KeyboardPage_keyboardGrid__HazIe {
  display: grid;
  grid-template-columns: 1fr 260px;
  gap: 12px;
  align-items: start;
}

/* LEFT side */
.KeyboardPage_left__bSIFx {
  display: grid;
  gap: 10px;
}

.KeyboardPage_row__abYXa {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;

  /* ✅ центрируем ряд (если где-то кнопок меньше) */
  justify-content: center;
}

.KeyboardPage_key__9htpK {
  flex: 1 1;
  height: 54px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.12);
  background: #f6f7f8;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  /* ✅ центрируем символ внутри кнопки */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.KeyboardPage_key__9htpK:hover {
  background: #eef1f3;
}

.KeyboardPage_wide__eC2Ep {
  flex: 3 1;
}

.KeyboardPage_mid__x5lk6 {
  flex: 1.2 1;
}

/* RIGHT side */
.KeyboardPage_right__iJLD- {
  display: grid;
  gap: 8px;

  /* ✅ сам блок справа тоже по центру */
  justify-items: center;
}

.KeyboardPage_numRow__DNJH\\+ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  /* ✅ центрируем сетку */
  justify-content: center;
  width: 100%;
}

.KeyboardPage_numKey__AfEXd {
  height: 54px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.12);
  background: #ffffff;
  font-size: 18px;
  font-weight: 900;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  /* ✅ центрируем символ/иконку внутри кнопки */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.KeyboardPage_numKey__AfEXd:hover {
  background: rgba(0,0,0,0.05);
}

.KeyboardPage_numBack__9ySHR {
  background: #f6f7f8;
}

/* responsive */
@media (max-width: 900px) {
  .KeyboardPage_keyboardGrid__HazIe {
    grid-template-columns: 1fr 220px;
  }
}

@media (max-width: 700px) {
  .KeyboardPage_keyboardGrid__HazIe {
    grid-template-columns: 1fr;
  }

  .KeyboardPage_right__iJLD- {
    grid-template-columns: 1fr;
    justify-items: stretch;
  }

  .KeyboardPage_numRow__DNJH\\+ {
    width: 100%;
  }
}

.KeyboardPage_langTabs__BZYnD {
  display: flex;
  gap: 6px;
  padding: 4px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.10);
  background: #ffffff;
}

.KeyboardPage_langBtn__iQp6i {
  height: 36px;
  min-width: 48px;
  padding: 0 10px;
  border-radius: 10px;
  border: none;
  background: #f6f7f8;
  font-weight: 900;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.KeyboardPage_langBtn__iQp6i:hover {
  background: #eef1f3;
}

.KeyboardPage_langActive__0jP\\+u {
  background: rgba(29, 135, 82, 1);
  color: #fff;
}

/* Caps state */
.KeyboardPage_capsActive__MfSEZ {
  background: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
}

.KeyboardPage_capsActiveKey__68xdw {
  background: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
}

.KeyboardPage_ctrlBtn__nZyU-:focus,
.KeyboardPage_ctrlBtn__nZyU-:focus-visible,
.KeyboardPage_okBtn__Ej3Ec:focus,
.KeyboardPage_okBtn__Ej3Ec:focus-visible,
.KeyboardPage_closeBtn__7w557:focus,
.KeyboardPage_closeBtn__7w557:focus-visible,
.KeyboardPage_langBtn__iQp6i:focus,
.KeyboardPage_langBtn__iQp6i:focus-visible,
.KeyboardPage_key__9htpK:focus,
.KeyboardPage_key__9htpK:focus-visible,
.KeyboardPage_numKey__AfEXd:focus,
.KeyboardPage_numKey__AfEXd:focus-visible {
  outline: none;
  box-shadow: none;
}

.KeyboardPage_ctrlBtn__nZyU-:active,
.KeyboardPage_ctrlBtn__nZyU-:focus,
.KeyboardPage_ctrlBtn__nZyU-:focus-visible,
.KeyboardPage_langBtn__iQp6i:active,
.KeyboardPage_langBtn__iQp6i:focus,
.KeyboardPage_langBtn__iQp6i:focus-visible,
.KeyboardPage_key__9htpK:active,
.KeyboardPage_key__9htpK:focus,
.KeyboardPage_key__9htpK:focus-visible,
.KeyboardPage_numKey__AfEXd:active,
.KeyboardPage_numKey__AfEXd:focus,
.KeyboardPage_numKey__AfEXd:focus-visible {
  background: inherit; 
}

.KeyboardPage_okBtn__Ej3Ec:active,
.KeyboardPage_okBtn__Ej3Ec:focus,
.KeyboardPage_okBtn__Ej3Ec:focus-visible {
  background: rgba(29, 135, 82, 1);
  color: #fff;
}

.KeyboardPage_langActive__0jP\\+u,
.KeyboardPage_langActive__0jP\\+u:active,
.KeyboardPage_langActive__0jP\\+u:focus,
.KeyboardPage_langActive__0jP\\+u:focus-visible {
  background: rgba(29, 135, 82, 1);
  color: #fff;
}

.KeyboardPage_capsActiveKey__68xdw,
.KeyboardPage_capsActiveKey__68xdw:active,
.KeyboardPage_capsActiveKey__68xdw:focus,
.KeyboardPage_capsActiveKey__68xdw:focus-visible {
  background: rgba(29, 135, 82, 1);
  color: #fff;
}

.KeyboardPage_ctrlBtn__nZyU-,
.KeyboardPage_okBtn__Ej3Ec,
.KeyboardPage_closeBtn__7w557,
.KeyboardPage_langBtn__iQp6i,
.KeyboardPage_key__9htpK,
.KeyboardPage_numKey__AfEXd {
  -webkit-tap-highlight-color: transparent;
}
.KeyboardPage_root__trOgd button:focus,
.KeyboardPage_root__trOgd button:focus-visible,
.KeyboardPage_root__trOgd button:active {
  background: inherit !important;
}
.KeyboardPage_root__trOgd .KeyboardPage_okBtn__Ej3Ec:focus,
.KeyboardPage_root__trOgd .KeyboardPage_okBtn__Ej3Ec:focus-visible,
.KeyboardPage_root__trOgd .KeyboardPage_okBtn__Ej3Ec:active {
  background: rgba(29, 135, 82, 1) !important;
  color: #fff !important;
}
.KeyboardPage_root__trOgd .KeyboardPage_langActive__0jP\\+u:focus,
.KeyboardPage_root__trOgd .KeyboardPage_langActive__0jP\\+u:focus-visible,
.KeyboardPage_root__trOgd .KeyboardPage_langActive__0jP\\+u:active,
.KeyboardPage_root__trOgd .KeyboardPage_capsActiveKey__68xdw:focus,
.KeyboardPage_root__trOgd .KeyboardPage_capsActiveKey__68xdw:focus-visible,
.KeyboardPage_root__trOgd .KeyboardPage_capsActiveKey__68xdw:active {
  background: rgba(29, 135, 82, 1) !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/KeyboardPage.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;;EAEb,mBAAmB;EACnB,yCAAyC;;EAEzC,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE;yCACuC;AACzC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;;EAEjB,iDAAiD;EACjD,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;;EAER,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;;EAER,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;EAYE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;EAChC,WAAW;AACb;;AAEA;;;;EAIE,gCAAgC;EAChC,WAAW;AACb;;AAEA;;;;EAIE,gCAAgC;EAChC,WAAW;AACb;;AAEA;;;;;;EAME,wCAAwC;AAC1C;AACA;;;EAGE,8BAA8B;AAChC;AACA;;;EAGE,2CAA2C;EAC3C,sBAAsB;AACxB;AACA;;;;;;EAME,2CAA2C;EAC3C,sBAAsB;AACxB","sourcesContent":[".root {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n\n  background: #ffffff;\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n\n  box-shadow: 0 -16px 40px rgba(0, 0, 0, 0.12);\n  padding: 12px 14px 14px;\n}\n\n.root {\n  font-family: \"Inter\", \"Noto Sans\", system-ui, -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\n/* top row */\n.topRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 800;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ctrlBtn {\n  height: 38px;\n  min-width: 54px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(0,0,0,0.12);\n  background: #f6f7f8;\n  font-weight: 800;\n  cursor: pointer;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.ctrlBtn:hover {\n  background: #eef1f3;\n}\n\n.okBtn {\n  height: 38px;\n  min-width: 64px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: none;\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  font-weight: 900;\n  cursor: pointer;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.okBtn:hover {\n  opacity: 0.95;\n}\n\n.closeBtn {\n  height: 38px;\n  width: 38px;\n  border-radius: 10px;\n  border: 1px solid rgba(0,0,0,0.12);\n  background: #fff;\n  cursor: pointer;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.closeBtn:hover {\n  background: rgba(0,0,0,0.05);\n}\n\n/* input */\n.inputRow {\n  margin-bottom: 12px;\n}\n\n.input {\n  width: 100%;\n  height: 44px;\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  border-radius: 12px;\n  padding: 0 12px;\n  font-size: 16px;\n  outline: none;\n}\n\n/* main grid */\n.keyboardGrid {\n  display: grid;\n  grid-template-columns: 1fr 260px;\n  gap: 12px;\n  align-items: start;\n}\n\n/* LEFT side */\n.left {\n  display: grid;\n  gap: 10px;\n}\n\n.row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap;\n\n  /* ✅ центрируем ряд (если где-то кнопок меньше) */\n  justify-content: center;\n}\n\n.key {\n  flex: 1;\n  height: 54px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,0.12);\n  background: #f6f7f8;\n  font-size: 16px;\n  font-weight: 900;\n  cursor: pointer;\n  user-select: none;\n\n  /* ✅ центрируем символ внутри кнопки */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.key:hover {\n  background: #eef1f3;\n}\n\n.wide {\n  flex: 3;\n}\n\n.mid {\n  flex: 1.2;\n}\n\n/* RIGHT side */\n.right {\n  display: grid;\n  gap: 8px;\n\n  /* ✅ сам блок справа тоже по центру */\n  justify-items: center;\n}\n\n.numRow {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n\n  /* ✅ центрируем сетку */\n  justify-content: center;\n  width: 100%;\n}\n\n.numKey {\n  height: 54px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,0.12);\n  background: #ffffff;\n  font-size: 18px;\n  font-weight: 900;\n  cursor: pointer;\n  user-select: none;\n\n  /* ✅ центрируем символ/иконку внутри кнопки */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.numKey:hover {\n  background: rgba(0,0,0,0.05);\n}\n\n.numBack {\n  background: #f6f7f8;\n}\n\n/* responsive */\n@media (max-width: 900px) {\n  .keyboardGrid {\n    grid-template-columns: 1fr 220px;\n  }\n}\n\n@media (max-width: 700px) {\n  .keyboardGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .right {\n    grid-template-columns: 1fr;\n    justify-items: stretch;\n  }\n\n  .numRow {\n    width: 100%;\n  }\n}\n\n.langTabs {\n  display: flex;\n  gap: 6px;\n  padding: 4px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,0.10);\n  background: #ffffff;\n}\n\n.langBtn {\n  height: 36px;\n  min-width: 48px;\n  padding: 0 10px;\n  border-radius: 10px;\n  border: none;\n  background: #f6f7f8;\n  font-weight: 900;\n  cursor: pointer;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.langBtn:hover {\n  background: #eef1f3;\n}\n\n.langActive {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n}\n\n/* Caps state */\n.capsActive {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n}\n\n.capsActiveKey {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n}\n\n.ctrlBtn:focus,\n.ctrlBtn:focus-visible,\n.okBtn:focus,\n.okBtn:focus-visible,\n.closeBtn:focus,\n.closeBtn:focus-visible,\n.langBtn:focus,\n.langBtn:focus-visible,\n.key:focus,\n.key:focus-visible,\n.numKey:focus,\n.numKey:focus-visible {\n  outline: none;\n  box-shadow: none;\n}\n\n.ctrlBtn:active,\n.ctrlBtn:focus,\n.ctrlBtn:focus-visible,\n.langBtn:active,\n.langBtn:focus,\n.langBtn:focus-visible,\n.key:active,\n.key:focus,\n.key:focus-visible,\n.numKey:active,\n.numKey:focus,\n.numKey:focus-visible {\n  background: inherit; \n}\n\n.okBtn:active,\n.okBtn:focus,\n.okBtn:focus-visible {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n}\n\n.langActive,\n.langActive:active,\n.langActive:focus,\n.langActive:focus-visible {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n}\n\n.capsActiveKey,\n.capsActiveKey:active,\n.capsActiveKey:focus,\n.capsActiveKey:focus-visible {\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n}\n\n.ctrlBtn,\n.okBtn,\n.closeBtn,\n.langBtn,\n.key,\n.numKey {\n  -webkit-tap-highlight-color: transparent;\n}\n.root button:focus,\n.root button:focus-visible,\n.root button:active {\n  background: inherit !important;\n}\n.root .okBtn:focus,\n.root .okBtn:focus-visible,\n.root .okBtn:active {\n  background: rgba(29, 135, 82, 1) !important;\n  color: #fff !important;\n}\n.root .langActive:focus,\n.root .langActive:focus-visible,\n.root .langActive:active,\n.root .capsActiveKey:focus,\n.root .capsActiveKey:focus-visible,\n.root .capsActiveKey:active {\n  background: rgba(29, 135, 82, 1) !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `KeyboardPage_root__trOgd`,
	"topRow": `KeyboardPage_topRow__t1bSF`,
	"title": `KeyboardPage_title__RnS69`,
	"controls": `KeyboardPage_controls__8gskj`,
	"ctrlBtn": `KeyboardPage_ctrlBtn__nZyU-`,
	"okBtn": `KeyboardPage_okBtn__Ej3Ec`,
	"closeBtn": `KeyboardPage_closeBtn__7w557`,
	"inputRow": `KeyboardPage_inputRow__rtXsH`,
	"input": `KeyboardPage_input__UoBkX`,
	"keyboardGrid": `KeyboardPage_keyboardGrid__HazIe`,
	"left": `KeyboardPage_left__bSIFx`,
	"row": `KeyboardPage_row__abYXa`,
	"key": `KeyboardPage_key__9htpK`,
	"wide": `KeyboardPage_wide__eC2Ep`,
	"mid": `KeyboardPage_mid__x5lk6`,
	"right": `KeyboardPage_right__iJLD-`,
	"numRow": `KeyboardPage_numRow__DNJH+`,
	"numKey": `KeyboardPage_numKey__AfEXd`,
	"numBack": `KeyboardPage_numBack__9ySHR`,
	"langTabs": `KeyboardPage_langTabs__BZYnD`,
	"langBtn": `KeyboardPage_langBtn__iQp6i`,
	"langActive": `KeyboardPage_langActive__0jP+u`,
	"capsActive": `KeyboardPage_capsActive__MfSEZ`,
	"capsActiveKey": `KeyboardPage_capsActiveKey__68xdw`
};
export default ___CSS_LOADER_EXPORT___;
